<div class="sol-tab-list">
  @if (dividerVisible$()) {
    <div class="sol-tab-list-divider"></div>
  }
  <div
    class="sol-tab-items-scroll-container"
    [class.sol-tab-items-scroll-container-fade-left]="previousVisible$()"
    [class.sol-tab-items-scroll-container-fade-right]="nextVisible$()"
    #tabsScrollContainer
  >
    <div class="sol-tab-items" role="tablist" #tabs>
      @for (tab of visibleTabs$(); track tab.id) {
        <div
          class="sol-tab-item"
          role="tab"
          [attr.aria-selected]="tab.selected"
          [class.sol-tab-item-selected]="tab.selected"
          [class.sol-tab-item-large]="large$()"
          (click)="selectTab(tab.id)"
          #tab
        >
          {{ tab.translatable ? (tab.name | translate) : tab.name }}
          @if (tab.tag) {
            <sol-tag [tag]="tab.tag" />
          }
        </div>
      }
    </div>
  </div>
  @if (previousVisible$()) {
    <div class="sol-tab-list-button-left">
      <sol-button
        [icon]="SolIcon.chevron_left"
        [type]="SolButtonType.transparent"
        (click)="onPreviousOffscreenTab()"
      ></sol-button>
    </div>
  }
  @if (nextVisible$()) {
    <div class="sol-tab-list-button-right">
      <sol-button
        [icon]="SolIcon.chevron_right"
        [type]="SolButtonType.transparent"
        (click)="onNextOffscreenTab()"
      ></sol-button>
    </div>
  }
  <ng-content select="[slot=actions]" />
</div>
<div class="sol-tab-content-scroll-container" [class.sol-tab-content-scroll-container-visible]="contentVisible$()">
  <div class="sol-tab-content-scroll-view">
    <div class="sol-tab-content" role="tabpanel">
      <ng-content></ng-content>
    </div>
  </div>
</div>
